//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from './Input';

export default {
    extends: Input,

    props: {
        suffix: String,
        noFloat: Boolean,
        noArrows: Boolean,
    },

    computed: {
        valueWithSuffix() {
            return (
                this.model == null ? null :
                !this.suffix ? this.model :
                `${this.model} ${this.suffix}`
            );
        },
    },

    methods: {
        onInput(value) {
            if (value === '' || value === null) {
                this.model = null;
                return;
            }

            const numValue = this.noFloat ? parseInt(value) : parseFloat(value);

            if (!Number.isNaN(numValue)) {
                this.model = numValue;
            }
        },
    },
};
